import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { TOKEN } from '../../_helpers/token';
import * as moment from 'moment';

export class Transaction extends React.Component {
    constructor(props) {
        super(props);

        this.columns = [
            {
                key: "dates",
                TrOnlyClassName: 'tsc',
                text: "Date Created",
                className: "tsc",
                align: "left"
            },
            {
                key: "closed1",
                TrOnlyClassName: 'tsc',
                text: "Closed",
                className: "tsc",
                align: "left"
            },

            {
                key: "date_closed1",
                TrOnlyClassName: 'tsc',
                text: "Date Closed",
                className: "tsc",
                align: "left"
            },

            {
                key: "wins1",
                TrOnlyClassName: 'tsc',
                text: "Wins",
                className: "tsc",
                align: "left"
            },
            {
                key: "won_amount1",
                TrOnlyClassName: 'tsc',
                text: "Won Amount",
                className: "tsc",
                align: "left"
            },
            {
                key: "win_permutation1",
                TrOnlyClassName: 'tsc',
                text: "Win Permutation",
                className: "tsc",
                align: "left"
            },
            {
                key: "bet_amount1",
                TrOnlyClassName: 'tsc',
                text: "Bet Amount",
                className: "tsc",
                align: "left"
            }
        ];
        this.config = {
            key_column: "tsc",
            length_menu: [50, 100, 150],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 50,
            show_length_menu: true,
            button: {
                csv: true,
                print: true,
                excel: true,
            },
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Enter Search...",
                no_data_text: "No data was found",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                },

            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };
    }

    componentDidMount() {
        this.getData();
    }



    getData = (queryString = "") => {
        axios.get(baseURL).then(res => {
            this.setState({
                isLoading: true,
            })
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": TOKEN
                }
            };
            let url = baseURL + "draw?" + queryString
            console.log("query", url);
            
            console.log("token", TOKEN)
            axios.all([
                axios.get(url, axiosConfig),
            ]).then(axios.spread((branchResponse) => {
                this.setState({
                    admins: branchResponse.data,
                    isLoading: false,
                },
                    function () {
                        var data = [];

                        if (this.state.admins.length > 0) {
                            for (let i = 0; i < this.state.admins.length; i++) {
                                this.setState({
                                    total: this.state.admins[0].total_page
                                })

                                let mclosed;
                                if (this.state.admins[i].closed === null) {
                                    mclosed = { closed1: "" };
                                } else {
                                    mclosed = { closed1: this.state.admins[i].closed.toString()};
                                }
                                let mdate_closed;
                                if (this.state.admins[i].date_closed === null) {
                                    mdate_closed = { date_closed1: "_" };
                                } else {
                                    mdate_closed = { date_closed1: moment(this.state.admins[i].date_closed).format('DD, MMM YYYY HH:mm:ss') };
                                }
                                let mwin_permutation;
                                if (this.state.admins[i].win_permutation === null) {
                                    mwin_permutation = { win_permutation1: "_" };
                                } else {
                                    mwin_permutation = { win_permutation1: this.state.admins[i].win_permutation };
                                }
                                let mwins;
                                if (this.state.admins[i].wins === 0) {
                                    mwins = { wins1: "0" };
                                } else {
                                    mwins = { wins1: this.state.admins[i].wins };
                                }
                                let mwon_amount;
                                if (this.state.admins[i].won_amount === 0) {
                                    mwon_amount = { won_amount1: "0.00" };
                                } else {
                                    mwon_amount = { won_amount1: this.state.admins[i].won_amount };
                                }
                                let mbet_amount;
                                if (this.state.admins[i].bet_amount === 0) {
                                    mbet_amount = { bet_amount1: "0.00" };
                                } else {
                                    mbet_amount = { bet_amount1: this.state.admins[i].bet_amount };
                                }

                                let date = { dates: moment(this.state.admins[i].date_created).format('DD, MMM YYYY HH:mm:ss') };


                                data.push(Object.assign(date, mclosed, mbet_amount,mdate_closed,mwins, mwon_amount, mwin_permutation, this.state.admins[i]));
                                this.setState({
                                    data: data
                                })
                                console.log("bugs", data);
                            }
                        } else {
                            this.setState({
                                data: data,
                                isLoading: false,

                            })
                            console.log("bugs", data);
                        }
                    }
                );
            }))
        })

    }

    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString);
    }


    render() {
        return (
            <div >
                < >
                    <Col md={12}>
                        <h4>Draw</h4><br />

                    </Col>
                    < Col md={12} lg={12} >
                        < Card >
                            <CardBody >
                                <div className="panel-body" >

                                    {this.state.isShowError ?
                                        <div className="alert alert-success" > {this.state.statusMessage}
                                        </div> : null
                                    }
                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columns}
                                        dynamic={true}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.total}
                                        onChange={this.tableChangeHandler} />
                                </div>
                            </CardBody>

                        </Card>
                    </Col>
                </>
            </div>
        )
    }
}